import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Menu from "../Menu/Menu";
import "./provedor.css";
import axios from "axios";
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";

const Dashboard = () => {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  useEffect(() => {
    dadosReposicao()
  }, []);


  const dadosReposicao = async ()=>{
    var logado = await localStorage.getItem('@logado');

    if(logado == null || logado != "S"){
      localStorage.clear()
      navigate('/adminseja')
    }

    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/listarProvedor.php',
      headers: {'Content-Type': 'application/json'},
      data: {token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token,idusuario:idusuario}
    };

    try {
      var dados = await axios(options);
      var resposta = dados.data;
      console.log(resposta)

      if(resposta.success == false){
        toast.error(resposta.message);
        navigate('/adminseja')
        return false;
      }

      setarDados(resposta.data)
        
    } catch (error) {
         console.log(error)
        toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }

  }


  const setarDados = async (dados)=>{
     setData(dados)
  }

  const clickDeletar = async (id)=>{
    Swal.fire({
      title: 'Você tem certeza que deseja deletar esse provedor?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
         apiDeletarProvedor(id)
      }  
    });
  }

  const apiDeletarProvedor = async (id)=>{
    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/deletarProvedor.php',
      headers: {'Content-Type': 'application/json'},
      data: {token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token,idusuario:idusuario,idprovedor:''+id}
    };

    try {
      var dados = await axios(options);
      var resposta = dados.data;
      console.log(resposta)

      if(resposta.success == false){
        toast.error(resposta.message);
        return false;
      }

       toast.success(resposta.message)
       await setData([])
       dadosReposicao()
        
    } catch (error) {
         console.log(error)
        toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }
  }

  const filteredData = data.filter(
    (row) =>
      row.nome.toLowerCase().includes(search.toLowerCase()) ||
      row.id.toString().includes(search) 
      
  );

  return (
    <>
    <div style={{flex:1}}>
        <div style={{flex:1}}>
          <Menu />
        </div>
    </div>
     
     <div className="containerMenu">
    
      <Paper style={{ padding: "20px", maxWidth: "1000px", margin: "20px auto" }}>
      <h2 style={{ textAlign: "center", color: "black",marginBottom:40 }}>Serviços</h2>
      <TextField
        label="Pesquisar"
        variant="outlined"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          marginBottom: "10px",
          borderRadius: "8px",
          background: "#f9f9f9",
        }}
      />
      
      <TableContainer component={Paper} style={{ borderRadius: "8px" ,maxWidth:900}}>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#303041" }}>
              <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                ID
              </TableCell>
              <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                Nome
              </TableCell>
              <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                ID Serviço
              </TableCell>

              <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                Valor
              </TableCell>
              <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((row, index) => (
              <TableRow
                key={row.id}
                style={{
                  backgroundColor: index % 2 === 0 ? "#e8f1f7" : "#ffffff",
                }}
              >
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.nome}</TableCell>
                <TableCell>{row.tokenlink}</TableCell>
                <TableCell>{row.valor}</TableCell>

                <TableCell>
                   <DeleteIcon style={{cursor:'pointer'}} onClick={()=>{clickDeletar(row.id)}}/>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
</div>
    </>
  );
};

export default Dashboard;
